// this file is generated by update_shopify_store_data.py at 2026-03-18 20:30:03.094695
var courses = [];